/**
 * What counts as a postcode we can plan a garden from, by its shape.
 *
 * One rule, used by every box that takes one, so a value accepted in one
 * place cannot be rejected in another. It only decides when a box asks the
 * backend; whether the garden's saved postcode can be planned from (the tabs,
 * Today's postcode step) is the backend's answer (the garden place,
 * useGardenPostcode), never this shape.
 *
 * US ZIP codes only for now (five digits, or ZIP+4): the forecast is the
 * National Weather Service's. Whether a well-shaped ZIP is a real place Grow
 * can plan for is the backend's to say (checkPostcode), and every save
 * checks it.
 *
 * Who uses it: Today's TodayPostcode and the profile's ProfileDetailsForm.
 *
 * @module postcode
 */

/**
 * True for a US ZIP's shape: 38583 or 38583-1234.
 *
 * @param value - As typed or saved; spaces around it are ignored.
 * @returns True for five digits, or five, a hyphen and four.
 */
export function isUsablePostcode(value: string | null | undefined): boolean {
  return /^\d{5}(-\d{4})?$/.test((value ?? '').trim());
}
